/**
 * Marital Status Service
 * HTTP operations for marital status catalog
 */

import { apiClient, API_CONFIG } from '@/api/core';
import type { ApiResponse } from '@/api/shared';
import type { LC_GetMaritalStatusOut, MaritalStatus } from './maritalStatus.types';
import { mapMaritalStatuses } from './maritalStatus.mapper';

/**
 * Service class for marital status catalog operations
 */
export class MaritalStatusService {
  /**
   * Get marital statuses by country
   * GET /v{version}/Catalog/marital-statuses/{countryId}
   */
  async getMaritalStatuses(countryId: number): Promise<ApiResponse<MaritalStatus[]>> {
    const endpoint = API_CONFIG.ENDPOINTS.CATALOG.MARITAL_STATUSES(countryId);
    const response = await apiClient.get<LC_GetMaritalStatusOut>(endpoint);

    if (!response.success || !response.data) {
      return { ...response, data: null };
    }

    const statuses = mapMaritalStatuses(response.data);
    return { ...response, data: statuses };
  }
}

export const maritalStatusService = new MaritalStatusService();
